import React from 'react';
import styled from 'styled-components';
import { ChartSortEnum } from '../../../interfaces';
import { theme } from '../../../../../styles/theme';
import { TableSortIcon } from '../../../../Icon';
import KubitTooltip from '../../../../KubitTooltip';
import { overflowingStyles } from '../../../../../styles/shareableStyles';

interface IProps {
  text: string;
  sort: ChartSortEnum;
}

const Container = styled.div`
  display: flex;
  column-gap: 4px;
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;
const Text = styled.div`
  max-width: 100%;
  ${overflowingStyles};
`;

const RetentionTableHeaderSort = ({ text, sort }: IProps) => {
  const isSortAsc = sort === ChartSortEnum.ASC;

  return (
    <KubitTooltip
      content={isSortAsc ? 'Ascending' : 'Descending'}
      placement="bottom"
      noOpenDelay={true}
    >
      <Container>
        <Text>{text}</Text>
        <TableSortIcon isSortAsc={isSortAsc} />
      </Container>
    </KubitTooltip>
  );
};

export default RetentionTableHeaderSort;
